import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Tipografías de la guía de marca, autoalojadas (@fontsource) en vez de tirar de
// Google Fonts: sin peticiones a terceros. Antes index.css pedía "Inter" sin que
// nadie la cargara, así que solo la veía quien la tuviera instalada; el resto
// caía a system-ui. Sora es únicamente para titulares.
// Solo el subconjunto latino: los paquetes completos traen cirílico, griego y
// vietnamita, que el service worker precacheaba enteros (~700 KB inútiles para
// una app en español).
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource/sora/latin-600.css'
import '@fontsource/sora/latin-700.css'

import './index.css'
import App from './App'
import { BrowserRouter } from "react-router-dom";
import ClerkProviderWithConfig from "./clerkConfig";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { initGTM } from './gtm';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './services/queryClient';
export { queryClient };

const ENV = import.meta.env.VITE_ENV;
const GTM_ID = import.meta.env.VITE_GTM_ID;

if (ENV === 'production' && GTM_ID) {
  initGTM(GTM_ID);
}

let container: HTMLElement | null = null;
let root: ReturnType<typeof createRoot> | null = null;

document.addEventListener('DOMContentLoaded', function(event) {
  if (!container) {
    container = document.getElementById('root');
    if (!container) {
      throw new Error('Root container missing in index.html');
    }
    root = createRoot(container);
  }

  if (root) {
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}> 
          <ClerkProviderWithConfig>
            <BrowserRouter>
              <App />
              <ToastContainer 
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </BrowserRouter>
          </ClerkProviderWithConfig>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </StrictMode>,
    );
  }
});